import {
  Box,
  Button,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Select,
  Icon,
  Td,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Spinner,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  FaCheck,
  FaCircle,
  FaExclamation,
  FaEye,
  FaFileExport,
  FaLink,
  FaPlay,
  FaPlus,
  FaTimes,
  FaTrash,
} from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState, useRecoilState } from "recoil";
import moment from "moment";
import { refreshGlobal } from "../../../atoms/refreshGlobal";
import {
  dateForAPI,
  dateForList,
  dateForListWithHours,
} from "../../../constants/dataFormat";
import PaymentApi from "../../../services/paymentApi";
import { selectedTransfer } from "../../../atoms/selectedTransferToDelete";
import {
  BLUEMONEDDBUTTONS,
  GRAY_NEUTRAL,
  ORANGEMONEDD,
  VARIANT,
  WHITE,
} from "../../../constants/colors";
import ClientFilterSelect from "../../../defaultComponents/ClientFilterSelect";
import DateDropdown from "../../../defaultComponents/dateDropdown";
import { goToAddPayment, goToAddPaymentNew } from "../../../routes/coordinator";
import { HamburgerIcon } from "@chakra-ui/icons";
import ModalDeleteConfirmation from "./components/modalDeleteConfirmation";
import ModalPaymentDetail from "./components/modalPaymentDetail";
import Pagination from "../../../defaultComponents/pagination";
import { JWTToken } from "../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { CNPJFormater, CPFFormater } from "../../../defaultFunctions/formaters";
import { baseURL } from "../../../services/api";
import md5 from "md5";
import ValueDropdown from "../listaDeVendas/defaultComponent/valueDropdown";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import ModalDetails from "./components/modalDetails";
import { permissions } from "../../../atoms/permissions";
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";

interface PaymentList {
  atualizadoEm: string;
  codigoBarras: string;
  cliente: {
    ativo: boolean;
    cnpj: string;
    email: string;
    id: number;
    idPlano: number;
    idPromocao: number;
    isCnpj: boolean;
    nome: string;
    nomeFantasia: string;
    razaoSocial: string;
    sobrenome: string;
  };
  pagamentosHistorico: [paymentHistorico];
  criadoEm: string;
  dataPagamento: string;
  descontos: number;
  id: number;
  idCliente: number;
  idStatus: number;
  juros: number;
  observacao: string;
  status: {
    id: number;
    status: string;
  };
  urlArquivo: string;
  urlRecibo: string;
  valorNominal: number;
  valorPagamento: number;
  vencimento: string;
}

export interface paymentHistorico {
  atualizadoEm: string;
  criadoEm: string;
  data: string;
  hora: string;
  id: number;
  idPagamento: number;
  idStatus: number;
  observacao: string;
}

export default function PaymentSolicitation() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState(Array<PaymentList>);
  const [isOpen, setIsOpen] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(Array<paymentHistorico>);
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const [openDelete, setOpenDelete] = useState(false);
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: moment().startOf("day").format(dateForAPI),
    finalDateFilter: moment().endOf("day").format(dateForAPI),
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const [idBoleto, setIdBoleto] = useState(0);
  const [details, setDetails] = useState({});

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  // const id = Number(jwtToken.idCliente);
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const id =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);

  const perms = useRecoilState(permissions)[0];

  let dias =
    moment(filtros.finalDateFilter).diff(filtros.initialDateFilter, "days") >=
    32;

  const navigate = useNavigate();

  async function Export() {
    try {
      setLoading(true);
      const response = await PaymentApi.exportPayment(
        filtros.statusFilter,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        Number(jwtToken.idCliente),
        ""
      );
      fileDownload(response, "pagamentos.xlsx");
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  async function getPaymentList() {
    try {
      setLoading(true);
      const response = await PaymentApi.getPaymentSolicitation(
        filtros.statusFilter,
        id,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        currentPage,
        pageSize,
        search,
        filtros.minValueFilter,
        filtros.maxValueFilter
      );
      setSalesList(response.data);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      setLoading(false);
      // console.log("response na lista", response.data);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getPaymentList();
    }
  }, [pages]);
  useEffect(() => {
    // if (id !== 0) {
    getPaymentList();
    // }
  }, [
    search,
    currentPage,
    pageSize,
    refresh,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.clientFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
    filtros.statusFilter,
    id,
  ]);

  interface StatusTypes {
    [chave: string]: JSX.Element;
  }

  const statusTypes: StatusTypes = {
    Efetivado: <FaCheck />,
    Processando: <FaExclamation />,
    Pendente: <FaExclamation />,
    "Remessa Gerada": <FaExclamation />,
    "Não efetivado": <FaExclamation />,
    Cancelado: <FaTimes />,
  };

  const arrayDeStatus = [
    { id: 1, status: "Pendente" },
    { id: 2, status: "Remessa Gerada" },
    { id: 3, status: "Processando" },
    { id: 4, status: "Efetivado" },
    { id: 5, status: "Cancelado" },
    { id: 6, status: "Não Efetivado" },
    { id: 7, status: "Pendente - Consumo" },
  ];

  function onChangeStatusFilter(e: any) {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
  }

  const statusOptions =
    arrayDeStatus &&
    arrayDeStatus.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.status,
      };
    });

  // const setSelectedTransferId = useSetRecoilState(selectedTransfer);

  return (
    <Flex flexDir={"column"} height="100%" width="100%" bgColor={WHITE}>
      <Box
        width={"100%"}
        height={"fit-content"}
        mt={"0.3%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex px={8} py={3} alignItems="center">
          <FaPlay color={BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            color={BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Boletos
          </Text>
        </Flex>
      </Box>
      <Flex
        width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        py={3}
        px={10}
        flexDirection={"column"}
      >
        <Text mb={2} fontWeight={"bold"}>
          Filtros
        </Text>
        <Flex width={"100%"} height={"100%"} justifyContent="space-evenly">
          {/* <Box w={"25%"}>
            <ClientFilterSelect filtros={filtros} setFiltros={setFiltros} />
          </Box> */}
          <DateDropdown filtros={filtros} setFiltros={setFiltros} />
          <ValueDropdown filtros={filtros} setFiltros={setFiltros} />
          <Select
            fontSize={"0.8rem"}
            placeholder="Filtrar por Status"
            maxW={"14%"}
            value={filtros.statusFilter}
            onChange={onChangeStatusFilter}
          >
            {statusOptions.map((item) => {
              return (
                <option value={item.value} key={item.key}>
                  {item.text}
                </option>
              );
            })}
          </Select>
          <Button
            bgColor={GRAY_NEUTRAL}
            color={WHITE}
            onClick={() => {
              setFiltros(initialValues);
            }}
          >
            Limpar Filtros
          </Button>
          <Button
            bg={"none"}
            color={BLUEMONEDDBUTTONS}
            isDisabled={loading || dias}
            onClick={() => {
              Export();
            }}
            mx="10px"
            isLoading={loading}
            textTransform={"uppercase"}
            leftIcon={<FaFileExport />}
          >
            <Text fontSize={"0.8rem"}>Exporte</Text>
          </Button>
          <Button
            bgColor={BLUEMONEDDBUTTONS}
            color={WHITE}
            onClick={() => {
              goToAddPaymentNew(navigate);
            }}
            isDisabled={
              user.idLoginTipo === 4
                ? perms &&
                  perms.findIndex((perm: any) => perm.idPermissoes === 37) !== -1
                  ? false
                  : true
                : false
            }
          >
            <Icon mr={2} as={FiPlus} />
            Novo Pagamento Online!
          </Button>
        </Flex>
      </Flex>

      {loading ? (
        <Flex
          width={"100%"}
          height={"80vh"}
          mt={"0.1%"}
          justifyContent={"center"}
          alignItems={"center"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <Spinner size={"lg"} color={VARIANT} />
        </Flex>
      ) : (
        <Box
          width={"100%"}
          height={"85%"}
          mt={"0.1%"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <TableContainer>
            <Table variant="striped" colorScheme="blue" size="sm">
              <Thead h="60px" position="sticky" top="0">
                <Tr>
                  <Th
                    w={"300px"}
                    borderRadius={"8px 0 0 8px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Data da Envio
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Beneficiário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    CPF/CNPJ do Beneficiário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Data de Pagamento
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Data do Vencimento
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Juros
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Desconto
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Valor a Pagar
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Situação
                  </Th>
                  <Th
                    w={"300px"}
                    borderRadius={"0 8px 8px 0"}
                    textAlign={"center"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {salesList &&
                  salesList.map((item: any, index: any) => {
                    return (
                      <Tr
                        key={index}
                        cursor="pointer"
                        onClick={() => {
                          // setIsOpen(true);
                          // setPaymentDetails(item.pagamentosHistorico);
                        }}
                      >
                        <Td borderRadius={"8px 0px 0px 8px"} fontSize={"0.7vw"}>
                          {moment(item.criadoEm).format(dateForListWithHours)}
                        </Td>
                        <Td fontSize={"0.7vw"} whiteSpace={"normal"}>
                          {item.nomeBeneficiario}
                        </Td>
                        <Td fontSize={"0.7vw"}>
                          {item.cnpjBeneficiario.length === 14
                            ? CNPJFormater(item.cnpjBeneficiario)
                            : CPFFormater(item.cnpjBeneficiario)}
                        </Td>
                        <Td fontSize={"0.7vw"}>
                          {moment(item.dataPagamento).format(dateForList)}
                        </Td>
                        <Td fontSize={"0.7vw"}>
                          {moment(item.vencimento).format(dateForList)}
                        </Td>
                        <Td>
                          {item?.juros.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td fontSize={"0.7vw"}>
                          {item?.descontos.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td fontSize={"0.7vw"}>
                          {(
                            item.valorNominal +
                            item.juros -
                            item.descontos
                          ).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td fontSize={"0.7vw"}>
                          {item.status.status === "Não efetivado" ? (
                            <Td>
                              <Tooltip
                                label={
                                  item.pagamentosHistorico[
                                    item?.pagamentosHistorico?.length - 1
                                  ].observacao
                                }
                                hasArrow
                                bg={ORANGEMONEDD}
                                color="white"
                                placement="auto-start"
                              >
                                {statusTypes.hasOwnProperty(
                                  item.status.status
                                ) ? (
                                  <Flex
                                    alignItems={"center"}
                                    justifyContent="flex-start"
                                  >
                                    {statusTypes[item.status.status]}
                                    <Flex ml={4}>{item.status.status}</Flex>
                                  </Flex>
                                ) : (
                                  item.status.status
                                )}
                              </Tooltip>
                            </Td>
                          ) : (
                            <Td>
                              {statusTypes.hasOwnProperty(
                                item.status.status
                              ) ? (
                                <Flex
                                  alignItems={"center"}
                                  justifyContent="flex-start"
                                >
                                  {statusTypes[item.status.status]}
                                  <Flex ml={4}>{item.status.status}</Flex>
                                </Flex>
                              ) : (
                                item.status.status
                              )}
                            </Td>
                          )}
                        </Td>
                        <Td borderRadius={"0px 8px 8px 0px"} fontSize={"0.7vw"}>
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Options"
                              icon={<HamburgerIcon />}
                              bgColor={BLUEMONEDDBUTTONS}
                              color={WHITE}
                              size={"sm"}
                            />
                            <MenuList>
                              {/* {item.status.status != "Cancelado" ? (
                              <MenuItem
                                icon={<FaTrash />}
                                onClick={() => {
                                  setIdBoleto(item.id);
                                  setOpenDelete(true);
                                }}
                              >
                                Cancelar Solicitação
                              </MenuItem>
                            ) : null} */}
                              <MenuItem
                                icon={<FaEye />}
                                onClick={() => {
                                  setIsOpen(true);
                                  setPaymentDetails(item.pagamentosHistorico);
                                }}
                              >
                                Visualizar Histórico
                              </MenuItem>
                              <MenuItem
                                icon={<FaPlus />}
                                onClick={() => {
                                  setOpenDetails(true);
                                  setDetails(item);
                                }}
                              >
                                Visualizar Detalhes
                              </MenuItem>
                              {item.status.status === "Efetivado" && (
                                <MenuItem
                                  icon={<FaLink />}
                                  as={"a"}
                                  target="_blank"
                                  href={
                                    item.urlRecibo
                                      ? `${baseURL}${
                                          item.urlRecibo.split("/api")[1]
                                        }&secret=${md5(
                                          `${item.idCliente}-${moment().format(
                                            "DD/MM/YYYY"
                                          )}`
                                        )}`
                                      : `${baseURL}/Imagem/recibo/boleto/${
                                          item.id
                                        }?secret=${md5(
                                          `${item.id}-${moment().format(
                                            "DD/MM/YYYY"
                                          )}`
                                        )}`
                                  }
                                >
                                  Visualizar Recibo
                                </MenuItem>
                              )}
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
          <ModalDeleteConfirmation
            isOpen={openDelete}
            setIsOpen={setOpenDelete}
            getTransferList={getPaymentList}
            id={idBoleto}
          />
          <ModalPaymentDetail
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            item={paymentDetails}
          />
          <ModalDetails
            isOpen={openDetails}
            setIsOpen={setOpenDetails}
            item={details}
          />
          <Flex width={"100%"} justifyContent="center" mt={8}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              pageSize={pageSize}
            />
            <Select
              value={pageSize}
              onChange={onChangeSize}
              size="sm"
              ml={5}
              maxW="70px"
              borderRadius="6px"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={25}>25</option>
            </Select>
          </Flex>
        </Box>
      )}
    </Flex>
  );
}
